<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {}
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped>

  #app
    font-family 'Avenir', Helvetica, Arial, sans-serif
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    -webkit-font-smoothing antialiased
    display flex
    flex-direction column
    height inherit
    // min-width 1275px
    // min-height 650px
    cursor default
</style>



// WEBPACK FOOTER //
// App.vue?ebe7d1c2